<template>
    <div class="mt-2" v-if="isCartItemsLoaded">
        <h3 class="form-label">{{ $t('checkout.categories.treatments') }}</h3>
        <div class="row ms-0" v-if="treatments && treatments.length > 0">
            <div
                class="col-lg-4 col-md-4 col-sm-4 col-xs-12 ps-0"
                v-for="(treatment, index) in treatments"
                :key="'t-' + treatment.pivot.id + index"
            >
                <div class="block box-abo mb-0" id="payment-attempt">
                    <div class="block-header border-bottom">
                        <h3 class="block-title fs-xs fw-medium text-center d-table p-2 m-auto">{{ treatment.name }}</h3>
                    </div>
                    <div class="block-content pb-2 pt-0 mb-0">
                        <div class="p-2">
                            <span class="fw-bold"></span>
                            <div class="w-100 d-flex flex-column mt-2">
                                <span class="fs-xs fw-medium text-center ppv2-text-black"
                                    >{{ $t('checkout.treatments.remaining_quantity') }} {{ treatment.pivot.quantity_left }}</span
                                >
                            </div>
                            <div class="mt-3 d-flex justify-content-center">
                                <button
                                    :ref="'treatmentRemoveBtn-' + treatment.pivot.id"
                                    type="button"
                                    class="btn-app-retir d-none"
                                    @click="removePrestations(treatment.pivot.id, 'treatment')"
                                >
                                    <!--<span>Retirer du panier</span>-->
                                    <span>{{ $t('common.remove') }}</span>
                                </button>
                                <button
                                    :ref="'treatmentApplyBtn-' + treatment.pivot.id"
                                    type="button"
                                    :class="{
                                        'btn-app-panier d-block m-auto': true,
                                        'disabled-btn': !canApplyTreatment(treatment),
                                    }"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-select-prestas"
                                    @click="changeSelected(treatment, 'treatment')"
                                    :disabled="!canApplyTreatment(treatment)"
                                >
                                    <!--<span>Appliquer au panier</span>-->
                                    <span>{{ $t('checkout.payment.apply') }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="alert alert-warning" role="alert">
                <p class="mb-0">{{ $t('checkout.treatments.no_treatments') }}</p>
            </div>
        </div>

        <serie-treatment-modal :selected="selected" @remove-selected="resetSelected"></serie-treatment-modal>
    </div>
</template>

<script>
import ApiManager from './_core/ApiManager'
import { sync, get } from 'vuex-pathify'

export default {
    data: () => ({
        treatments: null,
        selected: null,
        prepaidPrestations: [],
    }),
    async mounted() {
        if (!this.c_customer?.id) return
        await ApiManager.getTreatments(this.c_customer.id).then((res) => (this.treatments = res))
    },
    computed: {
        c_overlay: sync('overlay'),
        ...sync('overlay@data', {
            c_payments: 'payments',
            c_prepaidPrestations: 'prepaidPrestations',
        }),
        ...get('overlay@data', {
            c_customer: 'customer',
            c_cartItems: 'cartItems',
        }),
        isCartItemsLoaded() {
            return this.c_cartItems && Object.keys(this.c_cartItems).length > 0
        },
    },
    methods: {
        changeSelected(item, type) {
            this.selected = item
            this.selected.type = type
            this.changeBtn(this.selected.pivot.id, this.selected.type)
        },
        resetSelected() {
            this.selected = null
        },
        removePrestations(prepaidId, prepaidType) {
            this.c_prepaidPrestations = this.c_prepaidPrestations.filter(
                (p) => p.prepaid.id != prepaidId && p.prepaid.type != prepaidType
            )
            this.changeBtn(prepaidId, prepaidType)
        },
        changeBtn(prepaidId, type) {
            let removeBtn = null
            let applyBtn = null
            if (type === 'treatment') {
                removeBtn = this.$refs['treatmentRemoveBtn-' + prepaidId][0]
                applyBtn = this.$refs['treatmentApplyBtn-' + prepaidId][0]
            }

            if (removeBtn.classList.contains('d-none')) {
                removeBtn.classList.remove('d-none')
                applyBtn.classList.add('d-none')
            } else {
                removeBtn.classList.add('d-none')
                applyBtn.classList.remove('d-none')
            }
        },
        canApplyTreatment(treatment) {
            // console.log('canApply')
            let i = 0
            let canApply = false
            while (i < Object.keys(this.c_cartItems).length && !canApply) {
                let elementCart = this.c_cartItems[Object.keys(this.c_cartItems)[i]]
                // console.log('type', elementCart.options.type == 'App\\Models\\Prestation\\Prestation')
                // console.log(
                //     'includes',
                //     treatment.prestations.includes((x) => x.id == elementCart.relatedTo.id)
                // )
                // console.log('is_ticket', treatment.is_ticket == elementCart.is_ticket)
                let duration = elementCart.timeSlot?.duration_prestation
                canApply = duration
                    ? elementCart.options.type == 'App\\Models\\Prestation\\Prestation' &&
                      treatment.prestations.some(
                          (x) => x.pivot.prestation_id == elementCart.relatedTo.id && x.pivot.duration == duration
                      ) &&
                      treatment.is_ticket == elementCart.is_ticket
                    : elementCart.options.type == 'App\\Models\\Prestation\\Prestation' &&
                      treatment.prestations.some((x) => x.id == elementCart.relatedTo.id) &&
                      !treatment.is_ticket == elementCart.is_ticket
                i++
            }
            return canApply
        },
    },
}
</script>
<style scoped>
.btn-app-panier {
    background: #021832;
    padding: 4px 24px 4px 24px;
    border-radius: 8px;
    height: 40px;
    width: 118px;
    font-size: 12px;
    font-weight: 500;
    color: #fff;
}
.disabled-btn {
    opacity: 0.2;
}
.box-abo {
    min-width: 173px !important;
    background: #f8fafc;
    border-radius: 12px;
    border: solid 1px #94a3b833;
    padding: 0px 16px !important;
}
.btn-app-retir {
    background: #fbd080;
    padding: 4px 24px 4px 24px;
    border-radius: 8px;
    height: 40px;
    width: 118px;
    font-size: 12px;
    font-weight: 500;
    color: #fff;
}
</style>
